import Vue from 'vue'
import VueApollo from 'vue-apollo'

import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import {getGraphqlPublicUrl,getGraphqlPrivateUrl,getGraphqlWsPublicUrl,getGraphqlWsPrivateUrl} from './helpers/location'
import { IntrospectionFragmentMatcher, InMemoryCache } from 'apollo-cache-inmemory';
import privateIntrospectionQueryResultData from './fragmentTypesPrivate.json';
import publicIntrospectionQueryResultData from './fragmentTypesPublic.json';

const privateFragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: privateIntrospectionQueryResultData
});

const publicFragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: publicIntrospectionQueryResultData
});

const cachePrivate = new InMemoryCache({ fragmentMatcher: privateFragmentMatcher });
const cachePublic = new InMemoryCache({ fragmentMatcher: publicFragmentMatcher });



// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token';


// Http endpoint
const publicEndpoint = getGraphqlPublicUrl()
const privateEndpoint = getGraphqlPrivateUrl()
const wsEndpointPublic = getGraphqlWsPublicUrl()
const wsEndpointPrivate = getGraphqlWsPrivateUrl()


if (!publicEndpoint)
    throw "You have to define VUE_APP_GRAPHQL_PUBLIC_ENDPOINT env variable";

if (!privateEndpoint)
    throw "You have to define VUE_APP_GRAPHQL_PRIVATE_ENDPOINT env variable";


//
// // Files URL root
// export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'))
//
// Vue.prototype.$filesRoot = filesRoot

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)

  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,


  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
   apollo: {
     watchQuery: {
       fetchPolicy: 'network-only'
     },
     query: {
       fetchPolicy: 'network-only'
     }
   }
  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
}


const clientPublicOptions = {
    httpEndpoint: publicEndpoint,
    wsEndpoint: null,
    cache: cachePublic

}

const clientPrivateOptions = {
    httpEndpoint: privateEndpoint,
    wsEndpoint: null,
    cache: cachePrivate

}


// Call this in the Vue app file
export function createProvider (options = {}) {



  const createPublic = createApolloClient({
    ...defaultOptions,
    ...clientPublicOptions,
    ...options
  });

  const clientPublic = createPublic.apolloClient;
  clientPublic.wsClient = createPublic.wsClient;

  const  createPrivate = createApolloClient({
    ...defaultOptions,
    ...clientPrivateOptions,
    ...options
  });

  const clientPrivate = createPrivate.apolloClient;
  clientPrivate.wsClient = createPrivate.wsClient;



  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: clientPublic,
    clients: {
      clientPublic,
      clientPrivate
    },
    defaultOptions: {
      $query: {
        fetchPolicy: 'network-only',
      }
    },
    errorHandler (error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }

  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
}
